module.exports = __webpack_public_path__ + "img/video-close.40410791.png";